import React, { useCallback } from "react";
import styles from "./SmartTableFilter.module.css";
import { debounce } from "lodash";
import { Pagination } from "../Pagination/Pagination";

export const SmartTableFilter = ({ currentFilter, onChange, children, total }) => {
  const debouncedSearch = useCallback(debounce((search) => onChange({ ...currentFilter, Search: search }), 300), [onChange, currentFilter]);

  return (
    <div className={styles.container}>
      <form>
        <div className="form-group col-md-3 p-0">
          <div className="input-group">
            <input placeholder="Search..." className="form-control grid-search-input" value={currentFilter.searchValue} onChange={(e) => debouncedSearch(e.target.value)} />
            <span className="input-group-addon grid-search-icon">
              <i className="fa fa-search" />
            </span>
          </div>
        </div>
      </form>
      {children}

      <Pagination
        currentPage={Math.ceil(currentFilter.Skip / currentFilter.Take) + 1}
        onPageChange={(page) => onChange({ ...currentFilter, Skip: (page - 1) * currentFilter.Take })}
        pageSize={currentFilter.Take}
        totalCount={total}
        siblingCount={1}
      />
    </div>
  );
};
